import { useSelector } from "react-redux"
import { isValid, submit } from "redux-form"
import { customUserRQ } from "store/hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateOrCreateTestTakersFetch } from "store/middlewares/testTakers.crud"
import { queryClient as qc } from "keys"
import { pick } from "lodash"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { testTakerHooks } from ".."
import { useCallback, useContext } from "react"
import { CreateTestTakersContext } from "../CreateTestTakerContext"
import { useDispatch } from "react-redux"

const useSubmitBtns = () => {
    const queryClient = useQueryClient()
    const dispatch = useDispatch()

    const setAlert = testTakerHooks.useAlert()
    const cleanData = testTakerHooks.useCleanData()

    const isFormValid = useSelector(state => isValid("test_takers")(state));

    const { setErrorList } = useContext(CreateTestTakersContext)

    const { mutateAsync: updateOrCreateTestTakers, isPending: createTestTakerLoading } = useMutation({
        mutationFn: updateOrCreateTestTakersFetch,
        onSuccess: (res) => {
            setErrorList(res.data)
            toast("התלמידים התווספו בהצלחה", toastConfig)
            queryClient.invalidateQueries({ queryKey: [qc.getWithLastAssessments] })
            queryClient.invalidateQueries({ queryKey: [qc.testTakers] })
            queryClient.invalidateQueries({ queryKey: [qc.dashboard] })
        }
    })

    const formValues = useSelector(state => state.form["test_takers"]?.values)

    const updateOrCreate = async () => {
        if (isFormValid) {
            setErrorList([])
            let formData = {}
            const { school, grade, t_class, file } = formValues
            const { institution_code, name } = pick(school, ["institution_code", "name"])
            formData.institution_code = institution_code
            formData.school_name = name
            formData.grade = grade.id
            formData.t_class = t_class?.name
            formData.test_takers_file = file

            updateOrCreateTestTakers(formData)
        }
        else {
            dispatch(submit("test_takers"))
        }
    }

    const submitBtns = [
        {
            id: 0,
            label: "שמירה",
            action: updateOrCreate,
            color: "thirdly",
            loading: createTestTakerLoading,
        },
        {
            id: 0,
            label: "העלאת קובץ נוסף",
            action: cleanData,
            color: "thirdly4",
            loading: createTestTakerLoading,
        }
    ]

    return submitBtns
}

export default useSubmitBtns